import React, { useState } from "react";

const initialFollowers = Array.from({ length: 12 }, (_, index) => ({
  id: index,
  name: "ABC Limited",
  location: "Mumbai",
  imgSrc: require("../../../assets/BuyerProfile/Following/Ellipse.png"),
}));

const Following = () => {
  const [followers, setFollowers] = useState(initialFollowers);

  const handleRemove = (id) => {
    setFollowers(followers.filter((follower) => follower.id !== id));
  };

  return (
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] flex flex-col justify-between rounded-r-[10px] pt-[41px] px-[32px]">
      <h2 className="w-[129px] h-[27px] text-black font-semibold text-[18px]">
        My Followings
      </h2>

      <hr className="w-[194px] h-[2px] bg-[#FF6300]" />

      <div className="w-[960px] h-[500px] py-[15px] pl-[5px] flex flex-wrap overflow-y-scroll gap-x-[23px] gap-y-[31px]">
        {followers.map((follower) => (
          // <FollowCard />
          <div className="w-[221px] h-[309px] rounded-[10px] bg-white pt-[24px] pb-[17px] flex flex-col justify-start items-center drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <img
              className="w-[50px] h-[55px]"
              src={follower.imgSrc}
              alt="Company Logo"
            />
            <div className="flex items-center justify-center mt-[13px]">
              <p className="w-[104px] h-[26px] font-semibold text-[16px] text-black">
                {follower.name}
              </p>
              <img
                className="w-[17px] h-[17px]"
                src={require("../../../assets/BuyerProfile/Following/verified.jpg")}
                alt="Verified"
              />
            </div>

            <img
              className="w-[86px] h-[30px] rounded-[5px] mt-[12px]"
              src={require("../../../assets/BuyerProfile/Following/Frame 1171275510.jpg")}
              alt="Logo"
            />

            <div className="flex items-center justify-center gap-x-[4px] mt-[14px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
              >
                <g clip-path="url(#clip0_1626_2145)">
                  <path
                    d="M6.75 8.70825C6.75 9.33814 6.98705 9.94223 7.40901 10.3876C7.83097 10.833 8.40326 11.0833 9 11.0833C9.59674 11.0833 10.169 10.833 10.591 10.3876C11.0129 9.94223 11.25 9.33814 11.25 8.70825C11.25 8.07836 11.0129 7.47427 10.591 7.02887C10.169 6.58347 9.59674 6.33325 9 6.33325C8.40326 6.33325 7.83097 6.58347 7.40901 7.02887C6.98705 7.47427 6.75 8.07836 6.75 8.70825Z"
                    stroke="black"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.2428 13.1868L10.0605 16.5458C9.77924 16.8424 9.39794 17.009 9.00038 17.009C8.60282 17.009 8.22151 16.8424 7.94025 16.5458L4.75725 13.1868C3.91817 12.3011 3.34675 11.1726 3.11527 9.94403C2.88378 8.71549 3.00262 7.44209 3.45676 6.28484C3.91089 5.12759 4.67993 4.13848 5.66661 3.44258C6.6533 2.74668 7.81333 2.37524 9 2.37524C10.1867 2.37524 11.3467 2.74668 12.3334 3.44258C13.3201 4.13848 14.0891 5.12759 14.5433 6.28484C14.9974 7.44209 15.1162 8.71549 14.8847 9.94403C14.6533 11.1726 14.0818 12.3011 13.2428 13.1868Z"
                    stroke="black"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1626_2145">
                    <rect width="18" height="19" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p className="w-[62px] h-[20px] font-medium text-[14px] text-black">
                {follower.location}
              </p>
            </div>
            <div className="mt-[58px]">
              <button
                className="w-[99px] h-[37px] rounded-[5px] border-[1px] bg-white text-black font-medium text-[15px]"
                onClick={() => handleRemove(follower.id)}
              >
                Unfollow
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Following;
